import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { PackagesReducerHandlers, GeneralReducerHandlers } from './handlers';
import { GeneralActionTypes } from '../actions/types';

const packagesReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    ...PackagesReducerHandlers.fetchPackageByProjectId,
    ...PackagesReducerHandlers.fetchDataToCreateProject,
    ...PackagesReducerHandlers.fetchDataToEditProject,
    ...PackagesReducerHandlers.editProjectWithRelatedData,
    ...PackagesReducerHandlers.fetchPackageByCustomerId,
    ...PackagesReducerHandlers.fetchPackageForProofByProjectId,
    ...PackagesReducerHandlers.fetchProjectOverviewDataByProjectId,
    ...PackagesReducerHandlers.fetchProjectOverviewDataByCustomerId,
    ...PackagesReducerHandlers.fetchChaptersAndResourcesByProjectId,
    ...PackagesReducerHandlers.getBookSampleAndResourcesByProjectId,
    ...PackagesReducerHandlers.fetchChaptersAndResourcesByUser,
    ...PackagesReducerHandlers.getBookSampleAndResourcesByUser,
    ...PackagesReducerHandlers.getInterviewsInfo,
    ...PackagesReducerHandlers.fetchTimelineDataByCustomer,
    ...PackagesReducerHandlers.getDataForUpgradesByProjectId,
    ...PackagesReducerHandlers.completeUpgradeRequest,
  },
);

export default packagesReducer;
